import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { FiltersState } from './Filters.state';
import { Filter } from './Filters.style';

interface FiltersPropsType {
    className?: string,
    state: FiltersState,
    dataTest?: string
}

export const Filters = observer<FiltersPropsType>('Filters', (props) => {

    const { className, state, dataTest } = props;

    return (
        <nav className={className}>
            {state.filters.map((filter) => {
                const { id, key, label } = filter;
                const isActive = state.isFilterActive(id);
                const isDisabled = state.isFilterDisabled(id);
                const title = typeof label === 'string' ? label : undefined;

                return (
                    <Filter key={key}
                        title={title}
                        disabled={isDisabled}
                        onClick={state.bindSetActiveFilterId(id)}
                        isActive={isActive}
                        data-test={dataTest}
                    >
                        {label}
                    </Filter>
                );
            })}
        </nav>
    );

});
